import { DEFAULT_SHARED_QUERY_PARAM_KEYS } from '@app/constants'

const mergeSharedSearchParamKeysWithDefault = (sharedSearchParamKeys?: string[]): string[] => {
  return [...DEFAULT_SHARED_QUERY_PARAM_KEYS, ...(sharedSearchParamKeys ?? [])]
}

export default mergeSharedSearchParamKeysWithDefault
